import { render } from "./verify-phone.vue?vue&type=template&id=9ccba5a6"
import script from "./verify-phone.vue?vue&type=script&lang=js"
export * from "./verify-phone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__